export const enum LogLevelKind {
	SILENT = 0,
	INFO = 1,
	VERBOSE = 2,
	DEBUG = 3
}
